import { Button, Span } from "@goodfill/ui-components";

interface Props {
  onClick: () => void;
  isLoading: boolean;
  text: string;
}

export const StepSubmit: React.FC<Props> = ({ onClick, isLoading, text }) => {
  return (
    <div className="flex my-5 md:my-10 sm:w-80 w-full">
      <Button primary onClick={onClick} loading={isLoading} id={"next"} fill>
        <Span white font="semibold">
          {text}
        </Span>
      </Button>
    </div>
  );
};
